import { Col, Grid, Row } from "antd"
import React from "react"
import { clsx } from "~Shared/utils/clsx.utils"

const { useBreakpoint } = Grid

interface ExpenseFormLayoutProps {
    leftSide: React.ReactElement
    rightSide?: React.ReactElement
    /**
     * when converting an old form from a modal to a drawer set this to true
     *
     * TODO: once all forms are converted remove this prop
     */
    drawerMode?: boolean
    dualScroll?: boolean
}

export const ResponsiveFormLayout = ({ leftSide, rightSide, drawerMode = false, dualScroll = false }: ExpenseFormLayoutProps) => {
    const screens = useBreakpoint()

    if (!drawerMode) {
        return (
            <div className="animation-appear">
                <Row gutter={[16, 16]} className="flex-col md:flex-row">
                    <Col className={`${!rightSide && "min-w-full"}`} xs={24} lg={12}>
                        {leftSide}
                    </Col>
                    {rightSide && (
                        <Col xs={24} lg={12}>
                            {rightSide}
                        </Col>
                    )}
                </Row>
            </div>
        )
    }

    const wrapperCn = clsx("animation-appear", dualScroll && "h-full")
    const rowCn = clsx("flex-col md:flex-row", dualScroll && "h-full")

    return (
        <div className={wrapperCn}>
            {screens.xxl ? (
                <Row gutter={16} wrap={false} className={rowCn}>
                    <Col flex="700px">{leftSide}</Col>
                    <Col flex="auto">{rightSide}</Col>
                </Row>
            ) : (
                <Row gutter={16}>
                    <Col span={24}>{leftSide}</Col>
                    <Col span={24}>{rightSide}</Col>
                </Row>
            )}
        </div>
    )
}
